import { Box, Typography } from "@mui/material";
import BreadCrumbs from "../../components/Breadcrumbs";
import StyledTitleDot from "../../components/common/StyledTitleDot";
import TicketItems from "../../components/Tickets/TicketItems";
import { useTranslation } from "react-i18next";

export default function Tickets() {
  const { t } = useTranslation();

  return (
    <>
      <Typography className="title" variant="h4">
        {t("tickets")}
        <StyledTitleDot />
      </Typography>
      <BreadCrumbs routs={[t("tickets")]} />

      <Box>
        <TicketItems />
      </Box>
    </>
  );
}
